<template>

<Information />

<div class="bg-white py-12 px-8 my-8 mx-6">
    <h1 class="text-2xl font-bold mb-2">チャンネル管理</h1>

    <!-- 保存完了バナー -->
    <div v-if="showSavedBanner" class="alert-success items-center mb-4">
        <i class="fa-solid fa-circle-check text-emerald-500"></i>
        <p>保存に成功しました</p>
        <button type="button" class="alert-close link-styles--gray" @click="showSavedBanner = false">
            <i class="fa-light fa-xmark w-6 h-6" title="Close"></i>
        </button>
    </div>

    <!-- 保存失敗バナー -->
    <div v-if="showErrorBanner" class="alert-error items-center mb-4">
        <i class="fa-solid fa-triangle-exclamation text-alert"></i>
        <p>保存に失敗しました</p>
        <button type="button" class="alert-close link-styles--gray" @click="showErrorBanner = false">
            <i class="fa-light fa-xmark w-6 h-6" title="Close"></i>
        </button>
    </div>

    <div class="py-2 space-y-2">
        <p class="text-sm">チャンネル情報を入力してください。チャンネルURLの入力がお済みでない場合、記事投稿ができません。</p>
        <div class="flex items-center justify-end space-x-1 link-styles">
            <i class="fa-light fa-circle-question"></i>
            <a href="#" @click="showModal = true" class="text-sm">表示サンプルを確認する</a>
        </div>
    </div>

    <div class="flex flex-col md:flex-row items-start gap-6 mb-4 pt-3 md:pt-0">
        <div class="w-32 aspect-square shrink-0 rounded-full bg-slate-200
              flex items-center justify-center self-center md:self-start">
            <img v-if="!false && channel && channel.channel_icon" :src="channel.channel_icon" class="w-full h-full rounded-full">
            <i v-else class="fa-solid fa-user text-5xl text-slate-600"></i>
        </div>
        <div class="w-full">
            <div class="break-all pb-6 space-y-2">
                <p class="font-bold text-sm">チャンネルURL</p>
                <p>{{ channel.channel_url }}</p>
            </div>
            <div class="pb-6 space-y-2">
                <div class="space-x-2">
                    <label class="text-sm font-bold" for="accountName">アカウント名</label>
                    <span class="text-xs text-alert font-bold">必須</span>
                </div>
                <input id="accountName" v-model="channel.account_name" @input="validateForm" :class="['p-2 border rounded-sm w-full',errors.account_name ? 'border-alert' : 'border-gray-300']" />
                <p class="text-right text-sub text-xs">{{ channel.account_name.length }}/50</p>
                <p v-if="errors.account_name" class="text-alert text-sm font-bold">{{ errors.account_name }}</p>
            </div>

            <!-- #301: 通知用メールアドレス -->
            <div class="pb-6 space-y-2">
                <div class="space-x-2">
                    <label class="text-sm font-bold" for="applicationEmail">通知メールアドレス</label>
                    <span class="text-xs text-alert font-bold">必須</span>
                </div>
                <input
                    id="applicationEmail"
                    v-model="applicationEmail"
                    type="email"
                    placeholder="メールアドレスを入力"
                    @input="validateForm"
                    :class="['p-2 border rounded-sm w-full', errors.application_email ? 'border-alert' : 'border-gray-300']"
                />
                <p v-if="errors.application_email" class="text-alert text-sm font-bold">{{ errors.application_email }}</p>
            </div>

            <div class="pb-6">
                <label class="text-sm font-bold" for="channelDescription">チャンネル説明</label>
                <textarea id="channelDescription" v-model="channel.channel_description" @input="validateForm" placeholder="チャンネルについて説明してください。説明は、記事内に表示されます。" :class="['placeholder-placeholder p-2 border rounded-sm w-full h-32 mt-2',errors.channel_description ? 'border-alert' : 'border-gray-300']">
                </textarea>
                <p class="text-right text-sub text-xs">{{ channel.channel_description.length }}/160</p>
                <p v-if="errors.channel_description" class="text-alert text-sm font-bold">{{ errors.channel_description }}</p>
            </div>
        </div>
    </div>


    <div class="flex justify-end">
        <button @click="saveChannel" class="btn-primary">保存する</button>
    </div>

</div>
<!--サンプルモーダル-->
    <div v-if="showModal" class="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center p-4">
        <div class="bg-white rounded-lg overflow-hidden shadow max-w-md px-6 py-10 md:p-12 text-center">
            <div class="flex justify-between pb-4 items-center">
                <h3 class="text-xl font-bold">
                    表示サンプル
                </h3>
                <button @click="showModal = false" class="link-styles--gray">
                    <span class="sr-only">Close</span>
                    <i class="fa-light fa-xmark text-2xl" aria-hidden="true"></i>
                </button>
            </div>
            <img :src="sampleImg" alt="Sample" class="object-cover py-4 border-t border-b border-gray-300">
            <div class="mt-4">
                <button @click="showModal = false" class="btn-secondary">
                    閉じる
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {
    useStore
} from 'vuex';
import {
    ref,
    reactive,
    watch
} from 'vue';
import { useRouter } from 'vue-router';
import defaultIcon from '@/assets/defaultIcn.svg';
import Information from './InformationTable.vue';
import sampleImg from '@/assets/sampleImg.png';
export default {
    name: 'ChannelManagement',
    components: {
        Information
    },
    setup() {
        const store = useStore(); // Vuex ストアを使用
        const router = useRouter();
        const showModal = ref(false);
        const channel = reactive({
            channel_url: '',
            account_name: '',
            channel_description: '',
            channel_icon: '',
            id: '',
            is_owner: false,
        });
        const originalChannel = ref({});
        const errors = reactive({});
        const isEditable = ref(false);
        const showSavedBanner = ref(false);
        const showErrorBanner = ref(false);
        // 通知メールアドレス（チャンネルオーナーのもの）
        const applicationEmail = ref('');
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const fetchChannel = async () => {
            const accessToken = store.state.accessToken; // ストアからアクセストークンを取得
            const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
            try {
                const response = await axios.get(`${apiEndpoint}/channels/current`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                Object.assign(channel, response.data);
                originalChannel.value = JSON.parse(JSON.stringify(channel));
                // チャンネルオーナーの通知メールアドレスをセット
                applicationEmail.value = response.data.notification_email || '';
            } catch (error) {
                console.error("チャンネル情報の取得に失敗しました。", error);
                if (error.response.status === 302) {
                    console.log(error.response);
                    router.push(error.response.data.redirect_url || '/channel-application/form');
                }
            }
        };

        const validateForm = () => {
            // アカウント名のバリデーション
            errors.account_name = '';
            if (!channel.account_name) {
                errors.account_name = 'アカウント名は必須です。';
            } else if (channel.account_name.length > 50) {
                errors.account_name = 'アカウント名は50文字以内で入力してください。';
            }

            // 通知メールアドレスのバリデーション
            errors.application_email = '';
            if (!applicationEmail.value) {
                errors.application_email = 'メールアドレスは必須です。';
            } else if (!emailPattern.test(applicationEmail.value)) {
                errors.application_email = 'メールアドレスの形式が正しくありません。';
            }

            // チャンネル説明のバリデーション
            errors.channel_description = '';
            if (channel.channel_description.length > 160) {
                errors.channel_description = 'チャンネル説明は160文字以内で入力してください。';
            }
            // 変更があるかどうかをチェックし、エラーがない場合のみisEditableをtrueに設定
            const hasChanges = JSON.stringify(channel) !== JSON.stringify(originalChannel.value)
                || applicationEmail.value !== (originalChannel.value.notification_email || '');
            isEditable.value = hasChanges && Object.keys(errors).every(key => !errors[key]);
        };

        const saveChannel = async () => {
            validateForm();
            if (Object.keys(errors).some(key => errors[key])) return;

            const payload = {
                account_name: channel.account_name,
                channel_description: channel.channel_description,
                channel_icon: channel.channel_icon,
            };
            payload.notification_email = applicationEmail.value;
            const accessToken = store.state.accessToken;
            const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
            try {
                await axios.put(`${apiEndpoint}/channels/${String(channel.id)}/`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                });
                showErrorBanner.value = false;
                showSavedBanner.value = true;
                fetchChannel(); // 更新後の情報を再取得
            } catch (error) {
                console.error("保存に失敗しました。", error);
                if (error.response?.data?.notification_email) {
                    errors.application_email = error.response.data.notification_email;
                }
                showSavedBanner.value = false;
                showErrorBanner.value = true;
            }
        };

        watch(() => channel, validateForm, {
            deep: true
        });

        fetchChannel();

        return {
            channel,
            errors,
            isEditable,
            saveChannel,
            showSavedBanner,
            showErrorBanner,
            defaultIcon,
            showModal,
            sampleImg,
            applicationEmail,
        };
    },
};
</script>
